export default __webpack_public_path__ + "static/media/marker.b759f41b.svg";